import React, { useState } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { store, persistor } from 'reducers'
import { BrowserRouter as Router } from 'react-router-dom'
import { Routing } from 'navigation'

import Start from 'core'
import { BottomBar, CartDrawer, CategoriesDrawer, MenuDrawer, TopBar } from 'components'

function App() {
	const [categoriesOpen, setCategoriesOpen] = useState(false)
	const [menuOpen, setMenuOpen] = useState(false)

	const toggleCategoriesOpen = (openState) => {
		setCategoriesOpen(openState)
	}
	const toggleMenuOpen = (openState) => {
		setMenuOpen(openState)
	}

	return (<Provider store={store}>
		<PersistGate loading={<p>Loading...</p>} persistor={persistor}>
			<Start>
				<Router>
					<TopBar
						toggleMenuOpen={toggleMenuOpen}
					/>
					<CategoriesDrawer
						open={categoriesOpen}
						onToggle={(openState) => setCategoriesOpen(openState)}
					/>
					<MenuDrawer
						open={menuOpen}
						onToggle={(openState) => setMenuOpen(openState)}
						toggleCategoriesOpen={toggleCategoriesOpen}
					/>
					<CartDrawer />
					<Routing
						toggleCategoriesOpen={toggleCategoriesOpen}
					/>
					<BottomBar
						toggleCategoriesOpen={toggleCategoriesOpen}
					/>
				</Router>
			</Start>
		</PersistGate>
	</Provider>)
}

export default App
